import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const Popup = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem("hasSeenPopup");

    if (!hasSeenPopup) {
      setIsVisible(true);
      sessionStorage.setItem("hasSeenPopup", "true");
    }
  }, []);

  const closePopup = () => {
    setIsVisible(false);
  };

  // Function to close popup when clicking outside the popup content
  const handleOverlayClick = (event) => {
    if (event.target.classList.contains("popup-overlay")) {
      closePopup();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className="popup-content">
        <button className="popup-close" onClick={closePopup}>✖</button>
        <img src="/images/popup-image.jpg" alt="Welcome Popup" className="popup-image" />
      </div>
      <div className="popup-text flashing-text">
        {t("shisha_popup")}
      </div>
    </div>
  );
};

export default Popup;
